<div class="w-full flex text-small rounded-sm border border-[#0063a3] mt-4">
  <span class="bg-[#0063a3] w-5"></span>
  <md-icon class="text-[#0063a3] mx-3 mt-2">info</md-icon>
  <span class="mr-1 my-2">{{ translations.usage.text }}</span>
</div>

<div class="flex w-full mt-5">
  <modus-label class="text-xs grow">{{ translations.defaultTransparent.text }}</modus-label>
  <modus-switch
    id="3d-style-clearance-default-transparent-toggle"
    [formControl]="formGroup.controls.defaultTransparent"
  ></modus-switch>
</div>

<div
  class="flex w-full mt-3"
  [style.opacity]="formGroup.controls.defaultColor.enabled ? '1' : '0.3'"
>
  <modus-label class="text-xs grow">{{ translations.defaultColor.text }}</modus-label>
  <span class="w-[35px] h-5 -mt-[4px] mb-2">
    <sd-color-picker
      dialogPosition="bottom-left"
      [formControl]="formGroup.controls.defaultColor"
      tabindex="-1"
    ></sd-color-picker>
  </span>
</div>

<div class="flex items-center w-full mt-3 mb-3">
  <modus-label class="text-xs grow">{{ translations.bands.text }} ({{ lengthUnit() }})</modus-label>

  <button
    modus-icon-button
    keep-band-focus
    id="3d-style-clearance-remove-band"
    class="w-7 h-7 border-1 border-primary rounded-md text-primary"
    (click)="removeBand()"
    [disabled]="formBands.controls.length < 4"
  >
    <md-icon>remove</md-icon>
  </button>

  <button
    modus-icon-button
    keep-band-focus
    id="3d-style-clearance-add-band"
    class="w-7 h-7 ml-2 mr-1 border-1 border-primary rounded-md text-primary"
    (click)="addBand()"
  >
    <md-icon>add</md-icon>
  </button>
</div>

<ol class="mt-1">
  @for (item of formBands.controls; track item.value.id) {
    <li class="group flex w-full items-center text-xs h-9">
      <span class="mr-2 flex-grow">
        <sd-scan-3d-length-input
          [scan3dStyleUom]="scan3dStyleUom()"
          [focus]="item.controls.focus.value"
          [formControl]="item.controls.start"
          (focused)="setFocusedBand($index)"
          (blurred)="bandBlurred($event)"
          (enterPressed)="sortBands()"
        ></sd-scan-3d-length-input>
      </span>

      <span class="h-5 w-9">
        @if (!$last) {
          <sd-color-picker
            [formControl]="item.controls.color"
            dialogPosition="bottom-left"
            tabindex="-1"
          ></sd-color-picker>
        }
      </span>
    </li>
  }
</ol>

<div class="flex flex-row mt-1">
  @if (this.formGroup.invalid) {
    <div class="text-red text-xs mt-1 ml-1">{{ translations.errorInvalidBand.text }}</div>
  }
</div>
